import { createApi } from '@reduxjs/toolkit/query/react';
import { SSC_SEM_API_URL, TRACKED_WEBSITES_API_URL } from '../settings/config';
import { authRequest } from '../store/authorizedRequests';
import { MonitorRegionsData, SeoLocationData, SendOnboardingEventParams, SendOnboardingEventResponse } from './types';

const trackedWebsitesBaseUrl = `${TRACKED_WEBSITES_API_URL}`;
const TRACKED_WEBSITES_REFETCH_TIME = 7200;

const locationsAndLanguagesBaseUrl = `${SSC_SEM_API_URL}/dfs/locations`;
const LOCATIONS_AND_LANGUAGES_REFETCH_TIME = 7200;

export const trackedWebsitesApi = createApi({
    reducerPath: 'api.trackedWebsites',
    keepUnusedDataFor: TRACKED_WEBSITES_REFETCH_TIME,
    tagTypes: ['TrackedWebsites'],

    baseQuery: async (args, api, extraOptions) => {
        const { url, method, body, signal } = args;
        const { dispatch, getState } = api;
        try {
            const data = await authRequest(trackedWebsitesBaseUrl.concat(url), dispatch, getState, {
                method: method,
                body: JSON.stringify(body),
                signal: signal,
            });

            if (typeof data === 'undefined') {
                return { data: null };
            }

            return { data };
        } catch (error) {
            return { error };
        }
    },

    endpoints: (builder) => ({
        sendOnboardingEvent: builder.mutation<SendOnboardingEventResponse, SendOnboardingEventParams>({
            query: (arg) => ({
                url: '/onboarding',
                method: 'POST',
                body: arg,
            }),
        }),

        fetchMonitorRegions: builder.query<MonitorRegionsData, void>({
            query: () => ({
                url: '/regions',
                method: 'GET',
            }),
        }),
    }),
});

export const locationsAndLanguagesApi = createApi({
    reducerPath: 'api.locationsAndLanguages',
    keepUnusedDataFor: LOCATIONS_AND_LANGUAGES_REFETCH_TIME,

    baseQuery: async (args, api, extraOptions) => {
        const { url, method, body, signal } = args;
        const { dispatch, getState } = api;
        try {
            const data = await authRequest(locationsAndLanguagesBaseUrl.concat(url), dispatch, getState, {
                method: method,
                body: JSON.stringify(body),
                signal: signal,
            });

            return { data };
        } catch (error) {
            return { error };
        }
    },

    endpoints: (builder) => ({
        fetchLocationsAndLanguages: builder.query<SeoLocationData[], void>({
            query: () => {
                return {
                    method: 'GET',
                    url: '',
                };
            },
        }),
    }),
});

export const { useSendOnboardingEventMutation, useFetchMonitorRegionsQuery } = trackedWebsitesApi;
export const { useFetchLocationsAndLanguagesQuery } = locationsAndLanguagesApi;
